const EditCustomer = () => {
    return null;
}
export default EditCustomer;